import { useState } from 'react';

export const usePopToast = () => {
  const [isPop, setIsPop] = useState(false);
  const popToast = (timeout: number) => {
    try {
      setIsPop(true);
      setTimeout(() => {
        setIsPop(false);
      }, timeout);
    } catch {
      alert('This browser that does not support copying URLs.');
    }
  };

  return { isPop, setIsPop, popToast };
};
